import BaseObject from "./BaseObject.js";
import appConfig from '../../config/app_config';
export default class LocationObject {

  static _objectDefinition() {
    return {
      partnerId: '',
      locationId: '',
      name: '',
      description: '',
      picture: '',
      latitude: 0,
      longitude: 0,
      geofenceRadius: 10,
      polyline: 0,
      areaPerPerson: 10,
      latBottomLeft: 0.0,
      lonBottomLeft: 0.0,
      latTopRight: 0.0,
      lonTopRight: 0.0,
      publicTransportStops: '',
      street: '',
      nr: '',
      postalCode: '',
      city: '',
      country: '',
      telephone: '',
      webSite: '',
      defaultCapacity: 0,
      arrivalRateLimit: 0,
      departureRateLimit: 0,
      amountOfEntries: 0,
      arrivalRateSlot: 0,
      averageVisitDuration: 0,
      borderType: '',
      openingHours: '',
      email: '',
      depth: -1,
      entryType: 0, //normal location, 1 entry, 2 exit, 3 entry/exit
      tags: {},
      containers: {},
      categories: [],
      iconId: ''
    }
  }

  static _parseOsmObject(container) {
    let o = LocationObject._objectDefinition();
    let nodesProperty = BaseObject._createArrayWithObjects(container.Nodes)[0];

    let location = container.Tags;

    o.city = location.City;
    o.country = location.Country;
    o.description = location.Description;
    o.email = location.Email;
    o.areaPerPerson = location.AreaPerPerson;
    o.city = location.City;
    o.defaultCapacity = location.MaxCapacity;
    o.nr = location.Nr;
    o.openingHours = location.OpeningHours;
    o.telephone = location.Phone;
    o.postalCode = location.postalCode;
    o.name = location.ReferenceName;
    o.street = location.Street;
    o.subtype = location.SubType;
    o.website = location.Website;
    o.latitude = nodesProperty.Latitude;
    o.longitude = nodesProperty.Longitude;
    o.polyline = container.Polyline;

    return o;
  }

  /**
   * function to parse the replied property Map
   * in one array of objects
   */
  static _createArrayWithObjectsToArray(reply) {
    let outputArray = [];
    for (const [k, v] of Object.entries(reply)) {
      outputArray.push(v);
    }

    return outputArray;
  }

  static _parseLocationsInPropertyMatrix(locations) {
    let _result = BaseObject._createArrayWithObjects(locations);
    let result = BaseObject._toLowerCaseInitialProperty(_result);
    // adding custom properties
    result.forEach(e => {
      e.status = false,
        e.image = null,
        e.inset = true
    });

    return result;
  }

  static _createArrayWithObjects(locations) {
    let _result = this._createArrayWithObjectsToArray(locations);
    _result.forEach(e => {
      // if (e.MemberOf !== undefined && e.MemberOf.UserGroupsForLocation !== undefined) {
      //   e.MemberOf = BaseObject._createArrayWithObjects(e.MemberOf.UserGroupsForLocation);
      // }
    });

    let result = BaseObject._toLowerCaseInitialProperty(_result);
    // adding custom properties
    result.forEach(e => {
      e.status = false,
        e.image = null,
        e.inset = true
    });

    return result;
  }

  static _createArrayWithCapitalObjects(locations) {
    let _result = this._createArrayWithObjectsToArray(locations);
    _result.forEach(e => {
      // if (e.MemberOf !== undefined && e.MemberOf.UserGroupsForLocation !== undefined) {
      //   e.MemberOf = BaseObject._createArrayWithObjects(e.MemberOf.UserGroupsForLocation);
      // }
      e.Status = false;
      e.Image = null;
      e.Inset = true;
    });

    // let result = BaseObject._toLowerCaseInitialProperty(_result);
    // adding custom properties

    return _result;
  }

  static _createGetContainerRequest(object) {
    let o = {
      Polyline: object.polyline,
      Lat: object.latitude,
      Lon: object.longitude
    }

    return o;
  }

  static _createRequestObject(object, accounts) {
    let req = {
      PartnerId: Number(object.partnerId),
      Name: object.name,
      Description: object.description,
      Picture: object.picture,
      // MaxCapacity: object.maxCapacity,
      AreaPerPerson: object.areaPerPerson,
      Latitude: String(object.latitude),
      Picture: object.picture,
      Longitude: String(object.longitude),
      GeofenceRadius: Number(object.geofenceRadius),
      Polyline: object.polyline,
      LatBottomLeft: object.latBottomLeft,
      LonBottomLeft: object.lonBottomLeft,
      LatTopRight: object.latTopRight,
      LonTopRight: object.lonTopRight,
      OpeningHours: object.openingHours !== '' ? object.openingHours : '00:00-23:59',
      PublicTransportStops: object.publicTransportStops == undefined ? '' : object.publicTransportStops,
      Street: object.street == undefined ? '' : object.street,
      Nr: object.nr == undefined ? '' : object.nr,
      PostalCode: object.postalCode == undefined ? '' : object.postalCode,
      City: object.city == undefined ? '' : object.city,
      Country: object.country == undefined ? '' : object.country,
      Telephone: object.telephone == undefined ? '' : object.telephone,
      Website: object.website == undefined ? '' : object.website,
      Email: object.email == undefined ? '' : object.email,
      DefaultCapacity: Number(object.defaultCapacity),
      ArrivalRateLimit: Number(object.arrivalRateLimit),
      DepartureRateLimit: Number(object.departureRateLimit),
      AmountOfEntries: Number(object.amountOfEntries),
      ArrivalRateSlot: Number(object.arrivalRateSlot),
      AverageVisitDuration: Number(object.averageVisitDuration),
      BorderType: object.borderType,
      Depth: object.depth,
      EntryType: object.entryType, //normal location, 1 entry, 2 exit, 3 entry/exit
      Accounts: {},
      Tags: object.tags,
      Containers: {},
      IconId: object.iconId
    };
    // object.tags.forEach(e => req.Tags[e] = e);
    // object.container.forEach(e => {
    //   req.Containers[e.locationId] = 1;
    //   req.Depth = Number(e.depth) + 1
    // });
    Object.entries(object.containers)
      .forEach(([key, value]) => {
        req.Containers[value.locationId] = 1;
        req.Depth = Number(value.depth) + 1
      });
    // req.Containers[object.container.locationId] = 1;

    // if (object.container.depth != undefined)
    //   req.Depth = Number(object.container.depth) + 1;

    if (object.locationId !== "") {
      req.LocationId = object.locationId;
    }

    if (isNaN(req.Depth))
      req.Depth = 0;

    if (accounts.length > 0) {
      accounts.forEach(e => {
        req.Accounts[e.accountId] = e.accountId;
      });
    }

    return req;
  }
}
